import { Component, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { AppConstants } from '../constants/app-constants';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  loginError = false;
  loading = false;
  showPassword = false;
  errorMessage = '';

  @Output() loginSuccess = new EventEmitter<string>();

  constructor(
    private authService: AuthService,
    private router: Router,
    private languageService: LanguageService
  ) { }

  ngOnInit(): void {
    localStorage.setItem(AppConstants.IS_MOBILE, 'false');
  }

  toggleLanguage(): void {
    this.languageService.toggle();
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  clearError(): void {
    this.loginError = false;
    this.errorMessage = '';
  }

  async onSubmit(username: string, password: string): Promise<void> {
    if (!username?.trim() || !password) {
      this.showError('LOGIN.ERR_REQUIRED');
      return;
    }

    this.loading = true;
    this.clearError();

    try {
      const response: any = await this.authService.login(username.trim(), password);
      if (response.success) {
        const profile = this.authService.getUser();
        this.loginSuccess.emit(profile?.name || response.data.name);
        if (this.authService.isAdmin()) {
          this.router.navigate(['/main']);
        } else if (this.authService.isSupervisor()) {
          this.router.navigate(['/supervisor']);
        } else if (this.authService.isTeacher()) {
          this.router.navigate(['/teacher']);
        } else {
          this.showError('LOGIN.ERR_NO_ACCESS');
        }
      } else {
        this.showError(response.error || 'LOGIN.ERR_INVALID_RESPONSE');
      }
    } catch (error: any) {
      const message = error?.error?.errorMessages?.[0]?.message
        || 'LOGIN.ERR_GENERIC';
      this.showError(message);
    } finally {
      this.loading = false;
    }
  }

  private showError(message: string): void {
    this.loginError = true;
    this.errorMessage = message;
  }
}
